import buildCustomerPortalUrl, { CustomerPortalTenant } from './buildCustomerPortalUrl';

export default function buildCustomerPortalPreviewUrl(tenant: CustomerPortalTenant, path: string): string | null {
  const url = buildCustomerPortalUrl(tenant, path);

  if (!url) {
    return null;
  }

  const ending = path.includes('?') ? '&preview=true' : '?preview=true';

  return `${url}${ending}`;
}
